export const CF_URL: string = process.env.NEXT_PUBLIC_CF_URL || ''
export const LFS_URL: string = process.env.NEXT_PUBLIC_LFS_URL || ''
export const CF_FACEBOOK_ID: string = process.env.NEXT_PUBLIC_CF_FACEBOOK_ID || ''
